import React, { useState } from 'react';
import { CalendarDays } from 'lucide-react';
import './RescheduleChips.css';

// Move a due date without a form: tomorrow, next week, or pick a day. The
// value is written the way the action-item form writes it, a local
// datetime-local string at nine in the morning.
const pad = (n) => String(n).padStart(2, '0');
const localDay = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const atNine = (day) => `${day}T09:00`;

export function tomorrow(now = new Date()) { const d = new Date(now); d.setDate(d.getDate() + 1); return localDay(d); }
export function nextWeek(now = new Date()) { const d = new Date(now); d.setDate(d.getDate() + 7); return localDay(d); }

export default function RescheduleChips({ onPick, disabled = false, label = 'Reschedule' }) {
  const [picking, setPicking] = useState(false);
  return (
    <span className="reschedule" role="group" aria-label={label}>
      <button type="button" className="chip" onClick={() => onPick(atNine(tomorrow()))} disabled={disabled}>Tomorrow</button>
      <button type="button" className="chip" onClick={() => onPick(atNine(nextWeek()))} disabled={disabled}>Next week</button>
      {picking ? (
        <input
          type="date"
          className="chip-date"
          aria-label="Pick a day"
          autoFocus
          disabled={disabled}
          onChange={(e) => { if (e.target.value) { onPick(atNine(e.target.value)); setPicking(false); } }}
          onBlur={() => setPicking(false)}
          onKeyDown={(e) => { if (e.key === 'Escape') setPicking(false); }}
        />
      ) : (
        <button type="button" className="chip" onClick={() => setPicking(true)} disabled={disabled} aria-label="Pick a day"><CalendarDays size={13} aria-hidden="true" /> Pick</button>
      )}
    </span>
  );
}
